import { Palette } from "../../core/styles/theme";
import { Square } from "../components/Square";

export const ColorDocs = () => {
    return (
        <>
            <Square color={Palette.AeviBlack} text="AeviBlack" />
            <Square color={Palette.AeviRed} text="AeviRed" />
            <Square color={Palette.DarkGreen} text="DarkGreen" />
            <Square color={Palette.White} text="White" />
            <Square color={Palette.LightPink} text="LightPink" />
            <Square color={Palette.MenuScroll} text="MenuScroll" />
            <Square color={Palette.FormText} text="FormText" />
            <Square color={Palette.HeroGreen} text="HeroGreen" />
            <Square color={Palette.DisabledColor} text="DisabledColor" />
            <Square color={Palette.DisabledBackground} text="DisabledBackground" />
        </>
    );
};
